// @flow
import createReducer from '../utils/createReducer';
import type {Action, ActionType} from '../actions/searchBanner';
import type {ActionHandlers} from './ActionHandlers';

export type State = {
    dismissedLocations: {
        [string]: boolean
    }
};

const initialState: State = {
    dismissedLocations: {}
};

const actionHandlers: ActionHandlers<Action, ActionType, State> = {
    ['SEARCH_BANNER/ADD'](state, {payload}) {
        return {
            ...state,
            dismissedLocations: {
                ...state.dismissedLocations,
                [payload.location]: true
            }
        };
    }
};

export default createReducer(actionHandlers, initialState);
